/* RESPONSIBLE TEAM: team-reporting */

import { toPercentString } from '@/features/report-snapshots/formatters/percentage';
import { formatAxisValue } from '@/features/report-snapshots/formatters/y-axis-formatter';

function unitFormatter(value: number, unit: string) {
  if (unit === 'percent') {
    return toPercentString(value);
  } else if (unit === 'value') {
    return formatAxisValue(value);
  }
  return value;
}

export function setTargetLine(targetValue: number, unit: string) {
  const targetValuePosition = unit === 'percent' ? targetValue / 100 : targetValue;
  const targetValueFormatted = unitFormatter(targetValue, unit);

  return [
    {
      color: '#FF7F50',
      width: 2,
      value: targetValuePosition,
      zIndex: 10,
      label: {
        align: 'left' as const,
        verticalAlign: 'middle' as const,
        x: -15,
        y: 2,
        useHTML: true,
        formatter() {
          return `
                <span class="flex text-on-accent font-medium rounded-lg bg-accent-fill whitespace-nowrap px-2 h-5 items-center text-center justify-center">
                  ${targetValueFormatted}
                </span>
              `;
        },
      },
    },
  ];
}
